import { combineReducers } from "@reduxjs/toolkit";

import { baseApi } from "../services/baseApi";
import { authSliceReducer } from "../auth/authSlice";
// Import APIs to inject endpoints
import "../services/auth/authApi";
import "../services/purchaseOrder/purchaseOrderApi";
import "../services/notifications/notificationsApi";
import "../services/RFQs";

const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  auth: authSliceReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
